import React, { useState } from "react";
import { PlaceholderGroup } from "../../pluginsInfrastructure/PluginRegistryTypes";
import {
  Button,
  Card,
  FlexBox,
  H2,
  H3,
  Link,
  Typography,
  ModalDialog,
  ModalDialogBody,
  ModalDialogCloseButton,
  ModalDialogContent,
  ModalDialogNav,
} from "@vp/swan";
import "../../styles/DebugPluginComponent.scss";
import {
  PlaceholderGroupValidationResult,
  placeholderGroupValidationDescription,
} from "../../pluginsInfrastructure/PlaceholderGroupValidations";
import { GridContainer } from "@vp/swan";
import { Row } from "@vp/swan";
import { Column } from "@vp/swan";
import { H4 } from "@vp/swan";
import { Divider } from "@vp/swan";

export interface DebugPluginPlaceholderGroupProps extends React.PropsWithChildren {
  placeholderGroupType: PlaceholderGroup;
  validationResults?: PlaceholderGroupValidationResult;
}

export const DebugPluginPlaceholderGroup: React.FC<DebugPluginPlaceholderGroupProps> = props => {
  const { placeholderGroupType, validationResults, children } = props;
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const renderValidationResult = (result?: boolean) => (
    <FlexBox>
      <Typography fontSize={"xsmall"}>Result:&nbsp;</Typography>
      <Typography
        fontSize={"xsmall"}
        className={result ? "validation-result-passed" : "validation-result-failed"}
        textAllCaps
      >
        {result ? "passed" : "failed"}
      </Typography>
    </FlexBox>
  );

  const detailFlyout = (
    <ModalDialog
      isOpen={isDialogOpen}
      onRequestDismiss={() => {
        setIsDialogOpen(false);
      }}
      variant="panel-right"
      className={"debug-plugin-placeholder-group-modal-dialog"}
    >
      <ModalDialogContent>
        <ModalDialogNav>
          <ModalDialogCloseButton />
        </ModalDialogNav>
        <ModalDialogBody>
          <FlexBox flexDirection={"column"}>
            <H2 fontSize={"small"} mr={"3"}>
              {`Debug: placeholder group ${placeholderGroupType}`}
            </H2>
            <H3 fontSize={"xsmall"}>Placeholder group validation:</H3>
            {renderValidationResult(validationResults?.passed)}
            <H4 fontSize={"xsmall"}>Validations Run:</H4>
            <GridContainer>
              {validationResults?.validationsRun.map(validationRun => (
                <Row my={"3"}>
                  <Column span={12}>
                    <Card bordered>
                      <Typography fontSize={"xsmall"}>Type: {validationRun.type}</Typography>
                      <Typography fontSize={"xsmall"}>
                        Description: {placeholderGroupValidationDescription[validationRun.type]}
                      </Typography>
                      {renderValidationResult(validationRun.passed)}
                      <Typography fontSize={"xsmall"}>Details:</Typography>
                      <FlexBox ml={"5"} flexDirection={"column"}>
                        {Object.entries(validationRun.details).map(
                          ([placeholderType, componentNames]) => {
                            return (
                              <>
                                <Typography fontSize={"xsmall"}>
                                  Placeholder: {placeholderType}
                                </Typography>
                                <Typography fontSize={"xsmall"}>
                                  Component names: {componentNames.join(",")}
                                </Typography>
                                <Divider />
                              </>
                            );
                          }
                        )}
                      </FlexBox>
                    </Card>
                  </Column>
                </Row>
              ))}
            </GridContainer>
          </FlexBox>
        </ModalDialogBody>
      </ModalDialogContent>
    </ModalDialog>
  );

  return (
    <div className="debug-plugin-placeholder-group-container">
      <FlexBox className="debug-plugin-placeholder-group" flexDirection={"column"}>
        <FlexBox alignItems={"center"} justifyContent={"space-between"} darkMode>
          <Typography fontSize={"xsmall"} mr={"3"}>
            {`Placeholder Group: ${placeholderGroupType}`}
          </Typography>
          <Link
            render={p => (
              <Button
                skin="link"
                className={p.className}
                onClick={() => setIsDialogOpen(!isDialogOpen)}
              >
                {p.children}
              </Button>
            )}
          >
            <Typography fontSize={"xsmall"}>{`Details`}</Typography>
          </Link>
        </FlexBox>
      </FlexBox>
      {detailFlyout}
      {children}
    </div>
  );
};
